import { render, staticRenderFns } from "./RecipeForm.vue?vue&type=template&id=36e3f92d&"
import script from "./RecipeForm.vue?vue&type=script&lang=js&"
export * from "./RecipeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports